const DEFAULT_TEXTFIELD_WIDTH = '29rem';
const initialAddressInfo = {
  fullName: '',
  address1: '',
  address2: '',
  city: '',
  country: '',
  state: '',
  province: '',
  zipcode: '',
  phone: '',
  emailAddress: '',
  vatNumber: '',
  gstNumber: '',
};

export { initialAddressInfo, DEFAULT_TEXTFIELD_WIDTH };
